import { useEffect } from 'react';
import Router from './router';
import { initializeGTM } from './utils/gtm';


// Add dataLayer type declaration
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default function App() {

    const handleResize = () => {
        let parent: HTMLElement = document.getElementById("parent")!;
        if (window.innerWidth < 768) {
            parent.style.height = `${window.innerHeight}px`;
        }
    }

    useEffect(() => {
        // Initialize GTM when the app mounts
        initializeGTM();
        
        // Track initial page view
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pageview',
            page: {
                title: document.title,
                location: window.location.href,
                path: window.location.pathname
            }
        });

        // Existing resize logic
        let parent: HTMLElement = document.getElementById("parent")!;
        if (window.innerWidth < 768) {
            parent.style.height = `${window.innerHeight}px`;
        }
        window.addEventListener('resize', handleResize)
    }, []) // Added dependency array to prevent multiple initializations

    return (
        <div id="parent" className="md:h-screen w-full flex flex-col items-center justify-center md:text-[12px] text-[16px]">
            <div className="md:bg-phone w-full md:w-[316px] h-full md:h-[653px] md:bg-[length:316px_653px] relative">
                <div className="h-full md:h-[650px] overflow-y-auto mainContent">
                    <Router />
                </div>
                <div className="absolute hidden md:block bottom-[-38px] text-center w-full md:text-[14px] text-[16px]">YEWS IS DESIGNED FOR MOBILE</div>
            </div>
        </div>
    )
}